
import React from 'react'
import { getDateRestriction } from '..'

export function Slide({ s }) {
  const slide = (<div className='slider__item'>{s.component}</div>);
  const validDates = getDateRestriction(s)

  // if object not have property 'datesShow' than show slide
  if (!validDates.isExistDatesShow) return slide
  if (validDates.isValid) return slide

  // if current date not between start and end dates
  return null
}


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/impl/ui/Slide.jsx